import Vue from 'vue';
import Router from 'vue-router';
import Screen from './views/Screen.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      component: Screen
    }
  ]
});
